type FinalTranscriptHandler = (text: string) => void;

let handler: FinalTranscriptHandler | null = null;

export function setDictationOverrideHandler(
  next: FinalTranscriptHandler | null,
): void {
  handler = next;
}

export function hasDictationOverrideHandler(): boolean {
  return handler !== null;
}

export function runDictationOverride(text: string): boolean {
  if (!handler) return false;
  handler(text);
  return true;
}
